export default __webpack_public_path__ + "static/media/term-condition-cn.34ac2139.svg";